import { DMNNM, DMN } from './ops.js';
export const APK_FILE_NAME = "1xbook";
export const PAYINOUTMANUALNUMBERDEPOSIT = [{ number: '919687694941', label: '+91 96876-94941' }];
export const PAYINOUTMANUALNUMBERWITHDRAWAL = [{ number: '919712586957', label: '+91 97125-86957' }];
export const PAYINOUTMANUALNUMBERSUPPORT = [{ number: '919712586957', label: '+91 97125-86957' }];
export const DOMAINDISPLAY = { name: DMNNM, domain: DMN };
export const ABOUTUSNUMBER = [{ number: '+447456434607', label: '+44 7456 434607' }]
export const SOCIALMEDIALINKS = {
    whatsapp: "#",
    facebook: "#",
    twitter: "#",
    instagram: "#",
    telegram: "#",
    youtube: "#",
    whatsappDisplayNumber: "",
}
export const PAYINOUTMANUALEMAILSUPPORT = [{ email: 'info.hebebook@gmail.com', label: 'info.hebebook@gmail.com' }, { email: 'supp.hebebook2022@gmail.com', label: 'supp.hebebook2022@gmail.com' }];
export const PAYINOUTMANUALCOUNTRY = {
    'GE': [{ number: '+995592087447', label: '+995 592 087 447' }],
    'EU': [{ number: '+37259603836', label: '+372 5960 3836' }],
    'US': [{ number: '+13236570665', label: '+1 323 657 0665' }, { number: '+15513440165', label: '+1 551 344 0165' }]
}
export const ALLPAGEDISPLAYWHATSAPP = "";
export const ALLPAGEDISPLAYTELEGRAM = "";
export const ALLPAGEDISPLAYWHATSAPPSUPPORT = "";
export const ALLPAGEDISPLAYWHATSAPPACCOUNT = "";
export const ALLPAGEDISPLAYFEEDBACKWHATSAPPT = "";
export const ALLPAGEDISPLAYFEEDBACKEMAIL = "";
export const TOPHEADERDOWNLOADAPKBNNR = false;
